<template>
    <div class="main">
        <!-- <h5_nav ref="h5_nav" back_path="/h5/menu"></h5_nav> -->
        <!-- <div>
            常规项目{{ table_data }}
        </div> -->
        <Spin fix v-if="table_loading"></Spin>
        <div class="project_box_main">
            <div v-for="(item, i) in table_data" :key="i" class="project_block" @click="click_project_name(item)">
                <div class="project_box">
                    <div class="project_name">
                        {{ item.project_name }}
                    </div>
                    <div class="daimianshi_button">
                        待面试表
                    </div>
                </div>
            </div>
        </div>
        <div class="page_box">
            <Page :total="total_count" :page-size="limit" @on-change="page_change" />
        </div>

    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

import h5_nav from '../../component/h5_nav/index';
export default {
    components: {
        h5_nav
    },
    data() {
        return {
            page: 1,
            limit: 20,
            total_count: 0,
            table_data: [],
            columns: [],
            table_loading:false
        }
    },
    mounted() {
        this.get_my_project_list()
    },
    methods: {
        click_project_name(item){
            console.log(item)
            this.$router.push({
                path:'/h5/my_project/menu',
                query:{
                    project_id:item.project_id
                }
            })
        },

        page_change(e){
            this.page = e
            this.get_my_project_list()
        },

        //获取项目列表
        get_my_project_list() {
            var that = this
            var obj = {
                page: this.page
            }
            this.table_loading = true
            http("post", process.env.VUE_APP_HOST + "/my_project/project_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.table_data = res.data.project_list
                        that.columns = res.data.columns
                        that.limit = res.data.limit
                        that.total_count = res.data.total_count

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.table_loading = false
                }
            ).catch((res) => {
                that.table_loading = false

                console.log(res, '请求出错')
            })
        },
    }
}
</script>

<style scoped>


.daimianshi_button{
    display: flex;
    align-items: center;
    padding:2px 5px;
    color: rgb(166, 166, 166);
    background-color: rgb(231, 231, 231);
    font-size: 10px;
    border-radius: 3px;
}

.page_box{
    padding:0 0 30px 0;
    display: flex;
    justify-content: center;
}

.h5_nav {
    height: 50px;
    position: absolute;
    top: 0;
    left: 0;
}

.project_block {
    padding:5px 0;
    background-color: #fff;
}


.project_box_main {
    min-height: 90vh;
}

.project_name {
    font-size: 13px;
}

.main {
}

.project_box {
    border-bottom: 1px solid rgb(245, 245, 245);
    margin: 0 10px;
    padding: 10px;
    display: flex;
    justify-content: space-between;

}
</style>